<template>
  <div class="stock-vpt-view">
    <StockVPT />
  </div>
</template>

<script>
import StockVPT from '@/components/indicators/StockVPT.vue'

export default {
  name: 'StockVPTView',
  components: {
    StockVPT
  }
}
</script>

<style scoped>
.stock-vpt-view {
  min-height: 100vh;
}
</style>
